import React from 'react'

export default function MenuSearch() {
  return (
    <div>
      <h1>search 123</h1>
    </div>
  );
}
